import { render } from "./AddNews.vue?vue&type=template&id=8493ded2"
import script from "./AddNews.vue?vue&type=script&lang=js"
export * from "./AddNews.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__